const B2B_STORAGE_KEY = '@plumaa/b2b-pending-data';

export interface BenefitFormData {
	name: string;
	companyName: string;
	email: string;
	phone: string;
}

/**
 * Salva os dados do formulário de benefícios para persistir
 * durante o fluxo de login/cadastro.
 */
export const savePendingBenefitData = (data: BenefitFormData) => {
	try {
		localStorage.setItem(B2B_STORAGE_KEY, JSON.stringify(data));
	} catch (error) {
		console.error('Erro ao salvar dados temporários do B2B', error);
	}
};

/**
 * Recupera os dados pendentes, se houver.
 */
export const getPendingBenefitData = (): BenefitFormData | null => {
	try {
		const data = localStorage.getItem(B2B_STORAGE_KEY);
		return data ? JSON.parse(data) : null;
	} catch (error) {
		return null;
	}
};

/**
 * Limpa os dados temporários após o uso (sucesso).
 */
export const clearPendingBenefitData = () => {
	localStorage.removeItem(B2B_STORAGE_KEY);
};

/**
 * Verifica se existe um fluxo B2B pendente e retorna
 * a configuração de redirecionamento necessária.
 */
export const checkBenefitRedirection = () => {
	const pendingData = getPendingBenefitData();

	if (pendingData) {
		return {
			shouldRedirect: true,
			path: '/beneficios/planos',
			state: pendingData,
		};
	}

	return {
		shouldRedirect: false,
		path: null,
		state: null,
	};
};
